import { observer } from 'mobx-react';
import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'material-ui';
import _  from 'lodash';


@observer
export class WizTextField extends React.Component {

  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func
  };

  render() {

    const {
      id,
      className = '',
      type = 'text',
      placeholder,
      value,
      onChange,
    } = this.props;


    const textFieldProps = _.pickBy({
      id,
      type,
      className,
      placeholder,
      value,
      onChange,
      dir: 'auto'
    }, (v) => !_.isNull(v));

    if (!textFieldProps.id) {
      textFieldProps.id = textFieldProps.name;
    }

    return (
      <TextField { ...textFieldProps } />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/wiz-text-field/wiz-text-field.js